import { ThemeProvider } from "@/providers/ThemeProvider";
import { QueryProvider } from "@/providers/QueryProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { DataModeProvider } from "@/contexts/DataModeContext";
import { ErrorProvider } from "@/contexts/ErrorContext";
import { ErrorBoundary } from "@/components/error";
import { UserPreferencesProvider } from "@/providers/UserPreferencesProvider";
import { AppWithProviders } from "@/App";

interface AppContainerProps {
  settings?: unknown;
}

export default function AppContainer(_props: AppContainerProps) {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <ErrorProvider>
          <DataModeProvider>
            <UserPreferencesProvider>
              <TooltipProvider>
                <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} disableTransitionOnChange>
                  <Toaster richColors duration={5000} closeButton />
                  <AppWithProviders />
                </ThemeProvider>
              </TooltipProvider>
            </UserPreferencesProvider>
          </DataModeProvider>
        </ErrorProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
